import Vue from 'vue';
import Vuex from 'vuex';
import { readNotifstore } from './readNotifstore';  // Pastikan path sesuai
import { loadingStore } from './loadingStore'

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    cabang: null,
  },
  mutations: {
    SET_CABANG(state, payload) {
      state.cabang = payload
    },
  },
  modules: {
    readNotifstore,  // Tambahkan modul store di sini,
    loading: loadingStore,
  },
});

export default store;
